
export enum PortfolioCategory {
  General = 'General',
  RangeTime = 'Range-Time',
  Portrait = 'Portrait',
  Wedding = 'Wedding',
  Landscape = 'Landscape',
  Editorial = 'Editorial',
  Street = 'Street',
  Commercial = 'Commercial',
  Wildlife = 'Wildlife',
  Swimming = 'Swimming',
  Photo280Cowboys = 'Photo 280 - Cowboys',
  Photo280Columbia = 'Photo 280 - Columbia',
};
